import type { TKey } from '@/lib/i18n'

export type MailLinkFlow =
	| 'change_email_new'
	| 'change_email_old'
	| 'invite'
	| 'magic_link'
	| 'reset_password'
	| 'verify_email'

export type MailLinkState = 'missing' | 'ready'

export const MAIL_LINK_ROUTES = [
	{
		flow: 'reset_password',
		path: '/reset-password',
		requiresProof: true,
		sourceFile: 'reset-password.tsx'
	},
	{
		flow: 'verify_email',
		path: '/verify-email',
		requiresProof: true,
		sourceFile: 'verify-email.tsx'
	},
	{
		flow: 'verify_email',
		path: '/magic-link-verify-email',
		requiresProof: true,
		sourceFile: 'magic-link-verify-email.tsx'
	},
	{
		flow: 'magic_link',
		path: '/magic-link',
		requiresProof: true,
		sourceFile: 'magic-link.tsx'
	},
	{
		flow: 'change_email_old',
		path: '/change-email/confirm-old',
		requiresProof: true,
		sourceFile: 'change-email/confirm-old.tsx'
	},
	{
		flow: 'change_email_new',
		path: '/change-email/confirm-new',
		requiresProof: true,
		sourceFile: 'change-email/confirm-new.tsx'
	},
	{
		flow: 'invite',
		path: '/invite',
		requiresProof: false,
		sourceFile: 'invite.tsx'
	}
] as const satisfies ReadonlyArray<{
	flow: MailLinkFlow
	path: string
	requiresProof: boolean
	sourceFile: string
}>

const FLOW_COPY = {
	change_email_new: {
		destination: 'site:mail_link.flows.change_email_new.destination',
		subtitle: 'site:mail_link.flows.change_email_new.subtitle',
		title: 'site:mail_link.flows.change_email_new.title'
	},
	change_email_old: {
		destination: 'site:mail_link.flows.change_email_old.destination',
		subtitle: 'site:mail_link.flows.change_email_old.subtitle',
		title: 'site:mail_link.flows.change_email_old.title'
	},
	invite: {
		destination: 'site:mail_link.flows.invite.destination',
		subtitle: 'site:mail_link.flows.invite.subtitle',
		title: 'site:mail_link.flows.invite.title'
	},
	magic_link: {
		destination: 'site:mail_link.flows.magic_link.destination',
		subtitle: 'site:mail_link.flows.magic_link.subtitle',
		title: 'site:mail_link.flows.magic_link.title'
	},
	reset_password: {
		destination: 'site:mail_link.flows.reset_password.destination',
		subtitle: 'site:mail_link.flows.reset_password.subtitle',
		title: 'site:mail_link.flows.reset_password.title'
	},
	verify_email: {
		destination: 'site:mail_link.flows.verify_email.destination',
		subtitle: 'site:mail_link.flows.verify_email.subtitle',
		title: 'site:mail_link.flows.verify_email.title'
	}
} as const satisfies Record<
	MailLinkFlow,
	{ destination: TKey; subtitle: TKey; title: TKey }
>

export function getMailLinkCopy(flow: MailLinkFlow) {
	return FLOW_COPY[flow]
}

export function resolveMailLinkState(
	flow: MailLinkFlow,
	proof: string | undefined
): MailLinkState {
	const requiresProof = MAIL_LINK_ROUTES.some(
		(route) => route.flow === flow && route.requiresProof
	)

	return !requiresProof || proof?.trim() ? 'ready' : 'missing'
}
